/* tslint:disable */
var TSystemState = (function () {
    "use strict";
    var api = <any>{};

    // Overrides SystemSlipMode
    api.updateView = function () {
        TUniSlip.buildView();
    };

    // Template logic splitter
    api.buildOptions = function (selections) {
        this.calcVariants();
        return TMultiOptions.buildSystem(this, selections);
    };

    api.buildSelectionInnerView = function (__html, selection, selectionUpdated) {
        __html.push(TBuildLine.buildView(selection, this, { buildInner: true, updated: selectionUpdated, isSP: true }));
    };

    return api;
}());

window.TSystemState = TSystemState;